export enum ConfigurationCriteriaIdsEnum {
  'forecast-not-validated-since' = '1',
  'sales-deviation-forecast' = '2',
  'smape-last-months' = '3',
  'first-stocking-last-months' = '4',
  bestsellers = '5',
  top = '6',
  'tracking-signal' = '7',
  'destocking-last-days' = '8',
}
